var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 15,
  fill: "none",
  viewBox: "0 0 10 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "m.02.008 9.303 7.213L0 14.418.02 0z",
  opacity: 0.8
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0,
  x2: 9.323,
  y1: 7.221,
  y2: 7.221,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008129"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#008228"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#00A312"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#00B704"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BF00"
})))));
export { SvgTriangle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxMCAxNSIgZmlsbD0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnIG9wYWNpdHk9IjAuOCI+CiAgICA8cGF0aCBkPSJNMC4wMTk4MDUyIDAuMDA3OTgzNDdMOS4zMjM0OSA3LjIyMTAxTDAgMTQuNDE4MUwwLjAxOTgwNTIgMFYwLjAwNzk4MzQ3WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzc5MF8xMjA3KSIvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl83OTBfMTIwNyIgeDE9IjAiIHkxPSI3LjIyMTAyIiB4Mj0iOS4zMjM0OSIgeTI9IjcuMjIxMDIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzAwODEyOSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuMDEiIHN0b3AtY29sb3I9IiMwMDgyMjgiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjQzIiBzdG9wLWNvbG9yPSIjMDBBMzEyIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC43NyIgc3RvcC1jb2xvcj0iIzAwQjcwNCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMEJGMDAiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4K";